import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { onVehicleModelPhotoError, vehicleModelPhotoUrl } from '../../utils/nova-vehicle-photo';

/**
 * 차량 사진 (모델코드 · 외장 색상코드). 관리자 출고요청 폼, 화주사 출고요청 상세, 화주사 차량 상세가 같이 쓴다 (DOM-PDI-001 5.6)
 * - 사진 주소 규칙과 못 받을 때의 기본 사진은 utils/nova-vehicle-photo
 * - 크기(폭 · 비율)는 쓰는 곳이 정한다. 기본은 부모 폭에 4:3
 * - 사진을 받으면 차가 우상단 멀리서 가운데로 다가와 멈춘다 (사진의 차가 앞쪽 3/4 모습). 움직임 줄이기 설정이면 바로 보인다
 *
 * 예: <nova-vehicle-showcase class="vehicle-photo" [modelCode]="v.modelCode" [colorCode]="v.extColorCode" />
 */
@Component({
  selector: 'nova-vehicle-showcase',
  standalone: true,
  template: `<img [src]="src" [alt]="alt" (load)="onLoad()" (error)="onVehicleModelPhotoError($event)">`,
  styleUrl: './nova-vehicle-showcase.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.arrived]': 'arrived',
    '[class.animate]': 'animate',
  }
})
export class NovaVehicleShowcaseComponent implements OnChanges {

  @Input() modelCode?: string | null;
  @Input() colorCode?: string | null;
  /** 다가오는 애니메이션. false면 사진을 바로 보인다 */
  @Input() animate = true;
  @Input() alt = '차량 사진';

  src = vehicleModelPhotoUrl(null, null);

  /** 사진을 받았는지. 받은 뒤에 애니메이션을 시작한다 (늦게 받아도 빈 칸에서 끝나지 않게) */
  arrived = false;

  onVehicleModelPhotoError = onVehicleModelPhotoError;

  private cdr = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelCode'] || changes['colorCode']) {
      const next = vehicleModelPhotoUrl(this.modelCode, this.colorCode);
      if (next !== this.src) {
        // 다른 차가 되면 다시 들어온다
        this.src = next;
        this.arrived = false;
      }
    }
  }

  onLoad() {
    this.arrived = true;
    this.cdr.markForCheck();
  }
}
